module.exports = __webpack_public_path__ + "img/tpc-33.b09539d9.webp";